import { connect } from 'react-redux'
import { reduxForm, formValueSelector, change } from 'redux-form'
import { isPristine } from 'redux-form'
import { Input } from '../../common'
import { updateOrgSettings } from '../../../actions/settingsOrg'
import {
  BIG_FUTURE_AND_CONNECTIONS_FORM,
  BIG_FUTURE_AND_CONNECTIONS_FIELDS as FIELDS,
} from '../../../constants/SetupConstants'

const selector = formValueSelector(BIG_FUTURE_AND_CONNECTIONS_FORM)

const mapStateToProps = state => {
  const { selectedOrgId } = state.user.data
  const orgSettings = state.settingsOrg[selectedOrgId]
  const { updating, updated } = orgSettings || {}

  // Auto-fill checkbox if bigFuture object exists and cnxOptIn is true
  const bigFutureData = orgSettings?.data?.bigFuture
  const initialValues = {
    [FIELDS.CNX_OPT_IN.name]: bigFutureData && bigFutureData.cnxOptIn,
    [FIELDS.BFS_OPT_IN.name]: bigFutureData && bigFutureData.bfsOptIn,
  }
  const currentValues = {
    bfsOptIn:
      selector(state, FIELDS.BFS_OPT_IN.name) !== undefined
        ? selector(state, FIELDS.BFS_OPT_IN.name)
        : initialValues[FIELDS.BFS_OPT_IN.name],
    cnxOptIn:
      selector(state, FIELDS.CNX_OPT_IN.name) !== undefined
        ? selector(state, FIELDS.CNX_OPT_IN.name)
        : initialValues[FIELDS.CNX_OPT_IN.name],
  }

  const pristine = isPristine(BIG_FUTURE_AND_CONNECTIONS_FORM)(state)

  return {
    updating,
    updated,
    pristine,
    initialValues,
    currentValues,
    orgSettings,
  }
}

const BigFutureAndConnectionsFormComponent = ({
  handleSubmit,
  currentValues,
  pristine,
  updating,
  change,
}) => {
  const handleBigFutureChange = e => {
    const newBfsValue = e.target.checked
    if (!newBfsValue) {
      change(FIELDS.CNX_OPT_IN.name, false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        type="checkbox"
        name={FIELDS.BFS_OPT_IN.name}
        label="I opt in to Big Future."
        onChange={handleBigFutureChange}
        isRequired={FIELDS.BFS_OPT_IN.required}
      />
      <Input
        type="checkbox"
        name={FIELDS.CNX_OPT_IN.name}
        label="I opt in to Connections."
        disabled={!currentValues[FIELDS.BFS_OPT_IN.name]}
        isRequired={FIELDS.CNX_OPT_IN.required}
      />
      <button
        type="submit"
        disabled={pristine || updating}
        className="btn btn-sm btn-primary"
        style={{ position: 'relative', marginBottom: '40px' }}
        id="submit-big-future-and-connections-button"
      >
        Save
      </button>
    </form>
  )
}

const PanelForm = reduxForm({
  form: BIG_FUTURE_AND_CONNECTIONS_FORM,
  enableReinitialize: true,
  onSubmit: (data, dispatch, props) => {
    return dispatch(
      updateOrgSettings({
        ...props.orgSettings?.data,
        bigFuture: {
          ...props.orgSettings?.data?.bigFuture,
          bfsOptIn: data[FIELDS.BFS_OPT_IN.name],
          cnxOptIn: data[FIELDS.BFS_OPT_IN.name] ? data[FIELDS.CNX_OPT_IN.name] : false,
        },
      })
    )
  },
})(BigFutureAndConnectionsFormComponent)

export default connect(mapStateToProps, { change })(PanelForm)
